/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { MasterImportResponse } from '../model/masterImportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LocalityControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingDELETE6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingDELETE6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingDELETE6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingDELETE6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingGET6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingGET6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingGET6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingGET6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingHEAD6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingHEAD6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingHEAD6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingHEAD6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingOPTIONS6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingOPTIONS6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPATCH6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPATCH6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPATCH6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPATCH6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPOST6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPOST6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPOST6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPOST6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPUT6(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPUT6(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPUT6(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPUT6(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<Array<MasterImportResponse>>(`${this.basePath}/import/locality/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
